import { useSelector } from "react-redux";
import AdminDetailEditPanel from "../../components/Super/Admins/AdminDetailEditPanel";

const CreateAdmin = () => {
    const currentAdmin = useSelector((state) => state.user.untouched);
    return <AdminDetailEditPanel user={false} admin={currentAdmin} />;
};

export default CreateAdmin;
